import { Image as ThemeUIImage } from 'theme-ui';

const Image = (props) => <ThemeUIImage {...props}>{props.children}</ThemeUIImage>;

export default Image;
